import React from "react";
import { Modal, ModalBody, Button, Textarea } from "@windmill/react-ui";
import { useState } from "react";

const ConfirmActiveModal = ({ isOpen, onClose, onConfirm, status }) => {
  const [remarks, setRemarks] = useState("");
  const handleRemarkChange = (e) => {
    setRemarks(e.target.value);
  };
  const handleConfirm = () => {
    onConfirm(remarks);
    onClose();
  };

  const handleClose = () => {
    setRemarks("");
    onClose();
  };
  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalBody>
        <p className="text-lg">
          Are you sure to {status ? "Inactive" : "Active"}?
        </p>
        <div>
          <p className="text-lg font-medium mb-2">Enter remark</p>
          <Textarea
            name="block_remark"
            value={remarks}
            style={{
              minHeight: "100px",
              maxHeight: "300px",
              scrollbarWidth: "thin",
            }}
            onChange={handleRemarkChange}
          />
        </div>
        <div className="flex justify-end mt-4">
          <Button
            layout="outline"
            onClick={handleClose}
            className="w-full sm:w-auto hover:bg-white hover:border-gray-50"
          >
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={!remarks}>
            Confirm
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmActiveModal;
